export default "5cfe62515c2f9b42.woff2"